import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../../Constant";
import "./AnnouncementBanner.scss";

const TYPE_COLORS = {
  info: { bg: "#e8f4fd", border: "#2196F3", text: "#0d47a1" },
  warning: { bg: "#fff8e1", border: "#ff9800", text: "#e65100" },
  maintenance: { bg: "#fce4ec", border: "#f44336", text: "#b71c1c" },
  success: { bg: "#e8f5e9", border: "#4caf50", text: "#1b5e20" },
  banner: { bg: "#eef2ff", border: "#6366f1", text: "#312e81" },
  email_blast: { bg: "#e8f4fd", border: "#2196F3", text: "#0d47a1" },
  in_app: { bg: "#f0fdf4", border: "#22c55e", text: "#14532d" },
};

const AnnouncementBanner = () => {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    // Fetch from both the old and new announcement endpoints
    const fetchOld = fetch(`${API_BASE_URL}/announcements/active/`)
      .then((res) => res.json())
      .then((data) => (data.status && data.announcements ? data.announcements.map(a => ({ ...a, _source: "old" })) : []))
      .catch(() => []);

    const fetchNew = fetch(`${API_BASE_URL}/platform-announcements/active/`)
      .then((res) => res.json())
      .then((data) => (data.status && data.announcements ? data.announcements.map(a => ({ ...a, _source: "new" })) : []))
      .catch(() => []);

    Promise.all([fetchOld, fetchNew]).then(([oldAnns, newAnns]) => {
      const all = [...newAnns, ...oldAnns];
      // Filter out already-dismissed ones from localStorage
      const dismissed = JSON.parse(localStorage.getItem("dismissed_announcements") || "[]");
      const visible = all.filter((a) => !dismissed.includes(`${a._source}_${a.id}`));
      setAnnouncements(visible);
    });
  }, []);

  const handleDismiss = (announcement) => {
    const key = `${announcement._source}_${announcement.id}`;
    const dismissed = JSON.parse(localStorage.getItem("dismissed_announcements") || "[]");
    dismissed.push(key);
    localStorage.setItem("dismissed_announcements", JSON.stringify(dismissed));
    setAnnouncements((prev) => prev.filter((a) => `${a._source}_${a.id}` !== key));
  };

  if (announcements.length === 0) return null;

  return (
    <div className="announcement-banner-container">
      {announcements.map((announcement) => {
        const colors = TYPE_COLORS[announcement.announcement_type] || TYPE_COLORS.info;
        const isDismissible = announcement.is_dismissible !== false;
        return (
          <div
            key={`${announcement._source}_${announcement.id}`}
            className="announcement-banner"
            style={{
              backgroundColor: colors.bg,
              borderLeft: `4px solid ${colors.border}`,
              color: colors.text,
            }}
          >
            <div className="announcement-banner__content">
              <div className="announcement-banner__text">
                <strong className="announcement-banner__title">
                  {announcement.title}
                </strong>
                <span className="announcement-banner__message">
                  {announcement.message}
                </span>
                {announcement.link_url && (
                  <a
                    href={announcement.link_url}
                    className="announcement-banner__link"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: colors.border }}
                  >
                    {announcement.link_text || "Learn more"}
                  </a>
                )}
              </div>
            </div>
            {isDismissible && (
              <button
                className="announcement-banner__dismiss"
                onClick={() => handleDismiss(announcement)}
                aria-label="Dismiss announcement"
                style={{ color: colors.text }}
              >
                &times;
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AnnouncementBanner;
